import { FunctionComponent } from 'preact';

import { Typography } from '../Typography/Typography';
import { useTranslation } from '../../../../utils/useTranslation';
import { List } from '../List/List';
import { OverlayContent } from '../OverlayContent/OverlayContent';
import ns from '../../translations';
import { useCaptions } from '../../hooks/useCaptions';

export const Captions: FunctionComponent = () => {
  const { t } = useTranslation(ns);
  const { captionsList, selectedCaptions, selectCaptions } = useCaptions();

  return (
    <div>
      <List
        value={selectedCaptions}
        options={captionsList}
        onSelectedValueChange={selectCaptions}
      />
    </div>
  );
};
